import { render } from "./BasketAside.vue?vue&type=template&id=4be4403e"
import script from "./BasketAside.vue?vue&type=script&lang=js"
export * from "./BasketAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__